var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"c-card d-flex flex-column"},[_c('v-skeleton-loader',_vm._b({staticClass:"c-content-skeleton pb-4",attrs:{"types":{
      'content-image': 'image',
      'content-metadata': 'button@2',
      'content-action-bar': 'avatar@4'
    },"type":"\n      list-item-avatar-three-line,\n      content-image,\n      card-heading,\n      list-item-three-line,\n      content-action-bar\n    "}},'v-skeleton-loader',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }